import { useState } from "react";

import {
  QueryClient,
  QueryClientProvider,
} from "react-query";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Page from "./Container/Page";
import Landing from "./Container/Landing";

import FormBuilderList from "./Container/Admin/FormBuilder/FormBuilderList";
import FormBuilderEdit from "./Container/Admin/FormBuilder/FormBuilderEdit";
import FormBuilderNew from "./Container/Admin/FormBuilder/FormBuilderNew";
import About from "./Container/About";
import Form from "./Container/Form";
import Application from "./Container/Application";
import Participation from "./Container/Participation";
import { Box, useMediaQuery } from "@chakra-ui/react";
import Search from "./Container/Search";
import Donation from "./Container/Donation";
import BoardList from "./Container/Board/List";
import BoardView from "./Container/Board/View";
import Partnership from "./Container/Partnership";
import { theme } from "./assets/style/theme";

import './assets/style/xeicon/xeicon.css';
import Banner from "./Container/Banner";
import BoardWrite from "./Container/Board/Write";
import AboutEn from "./Container/About/AboutEn";
import LandingEn from "./Container/Landing/LandingEn";

const queryClient = new QueryClient();

type Props = {
  slug: string;
  type: string;
  query: string;
};

const RoutePage = ({type, slug, query}: any) => {
  const [params] = useState(
    Object.fromEntries(new URLSearchParams(query))
  );  

  switch (slug) {
    case "form-builder-list":
      return <FormBuilderList />;
    
    case "form-builder-edit":
      return <FormBuilderEdit params={params} />;
    
    case "form-builder-new":
      return <FormBuilderNew />;
    
    case "home":
      return <Landing />;
    
    case "about":
      return <About />;
    
    case "form":
      return <Form params={params} />;
    
    case "application":
      return <Application params={params} />;
    
    case "participation":
      return <Participation params={params} />;
    
    case "donation":
      return <Donation />;
    
    case "partnership":
      return <Partnership />;
    
    case "search":
      return <Search params={params} />;
    
    case "banner":
      return <Banner params={params} />;

    case "en": 
      switch (params.first) {
        case "about":
          return <AboutEn />;
        case "global-leadership":          
          return <Participation params={{slug: 'participation', first: '01', second: '06'}} />;
        case "global-seed-grant":          
          return <Participation params={{slug: 'participation', first: '03', second: '08'}} />;

        case "board":
          switch (params.mode) {
            case "view":
              return <BoardView params={params} />;
            case "write":
              return <BoardWrite params={params} />;
            case "edit":
              return <BoardWrite params={params} />;
            default:
              return <BoardList params={params} />;
          }        
        case "login":
          return <Page slug={slug} />;
        case "form":
          return <Form params={params} />;    
        default:
          return <LandingEn />
      }


    case "board":
        switch (params.mode) {
          case "view":
            return <BoardView params={params} />;
          case "write":
            return <BoardWrite params={params} />;
          case "edit":
            return <BoardWrite params={params} />;
          default:
            return <BoardList params={params} />;
        }
    
    default:
      return <Page slug={slug} />;
  }
};

function App({ slug, type, query }: Props) {
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <QueryClientProvider client={queryClient}>
      <Box className="App" pt={isMobile ? '48px' : '81px'} maxWidth="100%" overflowX="hidden">
        <RoutePage type={type} slug={slug} query={query} />
      </Box>
    </QueryClientProvider>
  );
}

export default App;
